import { DialogContent, Grid } from '@mui/material';

import { EventTypeSelect } from './EventTypeSelect';
import { StartTimePicker } from './StartTimePicker';
import { EndTimePicker } from './EndTimePicker';
import { PlaceForm } from './PlaceForm';
import { DescriptionForm } from './DescriptionForm';

export const Content = () => {
    return (
        <DialogContent sx={{ padding: '20px 5px' }}>
            <Grid container direction="column" p={2} spacing={2} width="85vw">
                <Grid item>
                    <EventTypeSelect />
                </Grid>
                <Grid item>
                    <StartTimePicker />
                </Grid>
                <Grid item>
                    <EndTimePicker />
                </Grid>
                <Grid item>
                    <PlaceForm />
                </Grid>
                <Grid item>
                    <DescriptionForm />
                </Grid>
            </Grid>
        </DialogContent>
    )
}
